// AUTO-GENERATED by scripts/generate-enabled-methods.mjs — do not edit; gitignored.
// Computed for stage local from apps/api/auth/.env.development + apps/api/auth/.env.local (key presence only).
import type { EnabledMethods } from "@workspace/auth-shared/methods";

export type { EnabledMethods };

export const ENABLED_METHODS: EnabledMethods = {
  "password": true,
  "magicLink": true,
  "passkey": true,
  "phone": false,
  "oauthProviders": [
    "google",
    "github",
    "slack",
    "atproto"
  ]
};
